export default __webpack_public_path__ + "static/media/OS_TienLen_CTY - VIE.781225ed.png";